import {
    UPLOAD_FILE_REQUEST,
    UPLOAD_FILE_REQUEST_FAILED,
    UPLOAD_FILE_REQUEST_SUCCESS,
    GET_TRANSCRIPT_LIST_TO_BE_RECORDED,
    GET_TRANSCRIPT_LIST_TO_BE_RECORDED_SUCCESS,
    GET_TRANSCRIPT_LIST_TO_BE_RECORDED_FAILED
} from './../constants/constants'

const initialState = {
    data: [],
    transcriptToBeRecorded: {
        data: []
    },
    success: {
        message: ""
    },
    error: {
        message: ""
    },
    loading: false


}


const UserManagement = (state = initialState, action) => {

    switch (action.type) {

        case GET_TRANSCRIPT_LIST_TO_BE_RECORDED:
            return {
                ...state,
                loading: true,
            };
            
        case GET_TRANSCRIPT_LIST_TO_BE_RECORDED_SUCCESS:
            //console.log(action.data.slice(0,2))
            return {
                ...state,
                loading: false,
                transcriptToBeRecorded: {
                    /*data: action.data.length === 0 ? [] 
                        : action.data.length <= 9 ? action.data 
                        : action.data.slice(0,9) */
                    data: action.data
                }
            };

        case GET_TRANSCRIPT_LIST_TO_BE_RECORDED_FAILED:
            return {
                ...state
            };

        case UPLOAD_FILE_REQUEST:

            return {
                ...state,
                success: {
                    message: ""
                },
                loading: true,
            }

        case UPLOAD_FILE_REQUEST_SUCCESS:

            return {
                ...state,
                success: {
                    message: "Audio File had been Saved!!!!"
                },
                loading: false,
            }

        case UPLOAD_FILE_REQUEST_FAILED:

            return {
                ...state,
                error: {
                    message: "Unable to Upload audio!!!"
                },
                loading: false,
            }

        default:
            return state
    }
}

export default UserManagement